// extracted by mini-css-extract-plugin
export default {"cont":"rankbar_cont__VsII5","totalP":"rankbar_totalP__zGa8y","partP":"rankbar_partP__6YwMF","txt":"rankbar_txt__2BMdO"};